module.exports = __webpack_public_path__ + "static/img/topLeftImg2.86ab431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topLeftImg2.png
// module id = 83YV
// module chunks = 1